import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs';
import { ZetraError } from '../shared/errors/error-messages.helper';
import { environment } from '../../../environments/environment';

export const zetraErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.url.includes(environment.baseUrl)) {
        if (error.error && error.error.errorCode) {
          throw error.error as ZetraError;
        }
        throw { result: false, errorCode: 'ZE99999' } as ZetraError;
      }
      //falback
      throw error;
    }),
  );
};
